import * as React from 'react'
import styled from 'styled-components'
import { Field } from 'react-final-form'
import { InputTextArea } from '../../atoms/input-text/index-textarea'
import { when } from '../../../utils/mixin'
import { Size, Color } from '../../../constants/app.constant'

interface Props {
  name: string
  type: string
  label: string
  icon?: React.ReactNode
  placeholder: string
  vertical?: Boolean
  horizontal?: Boolean
  required: boolean
  validate?: any
}

export default (props: Props) => (
  <Field name={props.name} validate={props.validate || undefined}>
    {({ input, meta }) => (
      <Wrapper vertical={props.vertical}>
        <div>
          {props.icon ? (
            <IconWrap>
              {props.icon}
              <Label
                required={props.required}
                color={Color.PALETTE_COLOR.LIGHT_GRAY}
              >
                {props.label}
              </Label>
            </IconWrap>
          ) : (
            <Label required={props.required}>{props.label}</Label>
          )}
        </div>

        <InputTextArea
          {...input}
          type={props.type}
          placeholder={props.placeholder}
          invalidMessage={meta.error && meta.touched && meta.error}
        />
      </Wrapper>
    )}
  </Field>
)

const Wrapper = styled.div<{
  vertical?: Boolean
}>`
  display: flex;
  width: 100%;
  ${when('vertical')(`
    flex-direction: column;
  `)};
`

const IconWrap = styled.div`
  display: flex;
  align-items: center;
  > * {
    &:first-child {
      margin-right: 2px;
    }
  }
`

const Label = styled.label<{ required: boolean; color?: string }>`
  display: inline-block;
  color: ${({ color = Color.PALETTE_COLOR.BLACK }) => color};
  font-size: ${Size.FONT.XSMALL}px;
  font-weight: ${Size.FONT_WEIGHT.BOLD};
  margin-bottom: 4px;
  ${when('required')(
    `
      position: relative;
      &:after {
        content: '*';
        position: absolute;
        top: -5px;
        right: -5px;
        color: ${Color.PALETTE_COLOR.STRONG_RED};
      } 
    `
  )};
`



// WEBPACK FOOTER //
// ./src/components/molecules/text-field/textarea-field.tsx